import React from 'react';
import { IAppliedFilter } from './filters';
import styles from './FilterCard.module.scss';
import trashIcon from 'v2/icons/trash-outlined.svg';

interface IFilterCardProps {
  appliedFilter: IAppliedFilter;
  onDeleteFilter: (filter: IAppliedFilter) => void;
  children: React.ReactNode;
  dataTestId?: string;
}

export const FilterCard = ({
  appliedFilter,
  onDeleteFilter,
  children,
  dataTestId,
}: IFilterCardProps) => {
  const handleClick = () => {
    onDeleteFilter(appliedFilter);
  };

  return (
    <div className={styles.card}>
      <div className={styles.content}>{children}</div>
      <button
        data-testid={dataTestId}
        className={styles.delete}
        onClick={handleClick}
      >
        <img src={trashIcon} alt="trash" />
      </button>
    </div>
  );
};
